// ─── A dónde puede mandar el asistente ──────────────────────────────────────
//
// VIVE EN `shared` PORQUE LA USAN LOS DOS LADOS: el servidor arma con ella la
// tabla que ve el modelo y valida lo que responde; el web le pone nombre al
// botón. Estuvo un rato duplicada —una copia en cada app— y nada impedía que se
// separaran: agregar una ruta en el servidor y olvidarse del web habría hecho
// que el botón mostrara la URL cruda, sin error y sin que nadie se enterara.
//
// POR QUÉ EXISTE. Explicar qué lleva un formulario y no decir dónde está deja a
// la persona sabiendo qué hacer y sin poder hacerlo. El director lo pidió así:
// además de describir, «mostrar la ruta o el link para que el usuario navegue».
//
// UNA RUTA NO ES UN RECORRIDO DE CLICS. `/assignments` es estable y sobrevive a
// un rediseño; «el botón azul de arriba a la derecha» no. Por eso las rutas SÍ
// van al corpus aunque los clics no.
//
// EL MODELO ELIGE DE ESTA LISTA, igual que cita de la lista de fuentes. Una
// ruta inventada manda a la persona a una pantalla que no existe, que es peor
// que no decirle nada — así que lo que no esté acá se descarta, exactamente
// como una cita a un documento desconocido.
//
// SÓLO RUTAS SIN PARÁMETROS. `/cap/:programId/cumplimiento` necesita saber QUÉ
// programa, y el asistente no lo sabe: mandaría a una URL rota. Las pantallas
// con parámetro se alcanzan desde su lista, que sí está acá.
export const ASSISTANT_ROUTES = [
    { path: '/people', label: 'Personas' },
    { path: '/students', label: 'Alumnos' },
    { path: '/admissions', label: 'Admisiones' },
    { path: '/sections', label: 'Secciones y Matrícula' },
    { path: '/curso', label: 'Curso' },
    { path: '/assignments', label: 'Tareas' },
    { path: '/grades', label: 'Libro de Notas' },
    { path: '/materiales', label: 'Material de Clase' },
    { path: '/academic', label: 'Programas & Cursos' },
    { path: '/academic/anuncios', label: 'Tablón de Anuncios' },
    { path: '/plantillas-syllabus', label: 'Plantillas Syllabus' },
    { path: '/catalogo-libros', label: 'Catálogo de libros' },
    { path: '/form-templates', label: 'Plantillas de formularios' },
    { path: '/encuestas', label: 'Encuestas' },
    { path: '/estandares', label: 'Estándares' },
    { path: '/dialogo-socratico', label: 'Diálogo socrático' },
    { path: '/practica-progreso', label: 'Progreso de práctica' },
    { path: '/tuition', label: 'Aranceles y Pagos' },
    { path: '/scholarships', label: 'Becas' },
    { path: '/cap', label: 'Camino TMAI' },
    { path: '/crm/contacts', label: 'CRM Contactos' },
    { path: '/crm/campaigns', label: 'Campañas CRM' },
    { path: '/crm/media', label: 'Biblioteca de Imágenes' },
    { path: '/usuarios', label: 'Usuarios del Sistema' },
    { path: '/settings', label: 'Configuración' },
    { path: '/reportes', label: 'Reportes e Indicadores' },
    { path: '/data-audit', label: 'Auditoría de datos' },
];
const KNOWN = new Set(ASSISTANT_ROUTES.map((r) => r.path));
/** La ruta si existe; `undefined` si el modelo la inventó. Se descarta en
 *  silencio, como una cita a un documento desconocido: la respuesta sigue
 *  sirviendo sin ella, y mandar a una pantalla inexistente no. */
export function validRoute(raw) {
    return typeof raw === 'string' && KNOWN.has(raw) ? raw : undefined;
}
/** La tabla que ve el modelo. Mismo formato que la de fuentes.
 *
 *  `shown` deja afuera las pantallas que este seminario no tiene (un módulo
 *  apagado): el modelo no puede elegir lo que no ve. Sin filtro, todas. */
export function routeTable(shown = () => true) {
    return ASSISTANT_ROUTES.filter((r) => shown(r.path))
        .map((r) => `  ${r.path} = ${r.label}`)
        .join('\n');
}
/** El nombre de una pantalla, para el botón. Una ruta sin nombre cae en la ruta
 *  misma, que sigue siendo navegable. */
export function routeLabel(path) {
    return ASSISTANT_ROUTES.find((r) => r.path === path)?.label ?? path;
}
//# sourceMappingURL=routes.js.map